import { AssetActionDialog } from '@/asset/components/action-dialog';
import { AssetActionTimeline } from '@/asset/components/action-timeline';
import { AssetErrorBoundary } from '@/asset/components/asset-error-boundary';
import { AssetInventoryDateControl } from '@/asset/components/asset-inventory-date-control';
import { AssetProposedEventGroupTimeline } from '@/asset/components/asset-proposed-event-group-timeline';
import { useAsset } from '@/asset/hooks/use-asset';
import { HardfinTabCardWrapper } from '@/components/hardfin-tab-card-wrapper';
import { useDisclosure } from '@/hooks/use-disclosure';
import { Box, Button, Stack, Typography } from '@mui/material';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/assets/$assetKey/')({
  component: AssetIndexRoute,
});

function AssetIndexRoute() {
  const { assetKey } = Route.useParams();

  return (
    <AssetErrorBoundary>
      <AssetIndexContent assetKey={assetKey} />
    </AssetErrorBoundary>
  );
}

function AssetIndexContent(props: { assetKey: string }) {
  const { asset } = useAsset(props.assetKey);
  const actionDialog = useDisclosure();

  return (
    <HardfinTabCardWrapper title="Basic info">
      <AssetActionDialog
        isOpen={actionDialog.isOpen}
        assetId={props.assetKey}
        onClose={actionDialog.close}
      />
      <Box display="grid" gridTemplateColumns="repeat(3, 1fr)">
        <Stack spacing={2} padding={2}>
          <Typography variant="subtitle2">Details</Typography>
          <Stack direction="row" alignItems="center" spacing={1}>
            <Typography variant="body2">Inventory date</Typography>
            <AssetInventoryDateControl asset={asset} />
          </Stack>
        </Stack>
        <Stack padding={2} spacing={2}>
          <Typography variant="subtitle2">Planned activity</Typography>
          <AssetProposedEventGroupTimeline asset={asset} />
        </Stack>
        <Stack padding={2}>
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
          >
            <Typography variant="subtitle2">Activity</Typography>
            <Button
              variant="contained"
              color="secondary"
              onClick={actionDialog.open}
            >
              Action
            </Button>
          </Stack>
          <AssetActionTimeline asset={asset} />
        </Stack>
      </Box>
    </HardfinTabCardWrapper>
  );
}
